export default __webpack_public_path__ + "static/media/design-system.ce4cb689.svg";